import { AbstractApi, ApiBaseResponse } from '../../../common/api'
import { InvitedUser, InviteUserDto, User } from '../types/user.types'

class UserApi extends AbstractApi {
  protected url = 'user'

  public async update(dto: Partial<User>): Promise<ApiBaseResponse<User>> {
    const { data: response } = await this.put<ApiBaseResponse<User>>(this.url.concat('/profile'), dto)

    return response
  }

  public async getUserInvitation(invitationToken: string): Promise<ApiBaseResponse<InvitedUser>> {
    const { data: response } = await this.get<ApiBaseResponse<InvitedUser>>(this.url.concat(`/invitation/${invitationToken}`))

    return response
  }

  public async getInvitedUsers(): Promise<ApiBaseResponse<InvitedUser[]>> {
    const { data: response } = await this.get<ApiBaseResponse<InvitedUser[]>>(this.url.concat('/invitation'))

    return response
  }

  public async inviteUser(user: InviteUserDto): Promise<ApiBaseResponse<InvitedUser>> {
    const { data: response } = await this.post<ApiBaseResponse<InvitedUser>>(this.url.concat('/invitation'), user)

    return response
  }

  public async getUsers(withInvitedUsers: boolean): Promise<ApiBaseResponse<User[]>> {
    const { data: response } = await this.get<ApiBaseResponse<User[]>>(this.url, { withInvitedUsers })

    return response
  }

  public async submitQuiz(): Promise<ApiBaseResponse<any>> {
    const { data: response } = await this.post<ApiBaseResponse<any>>(this.url.concat('/submit-quiz'), {})

    return response
  }

  public async updateAvatar(formData: FormData): Promise<ApiBaseResponse<User>> {
    const { data: response } = await this.post<ApiBaseResponse<User>>(this.url.concat('/avatar'), formData, {
      'Content-Type': 'multipart/form-data',
    })

    return response
  }
}

export const userApi = new UserApi()
